import React, { useState, lazy } from 'react';
import { ThumbsUp, BadgeCheck } from 'lucide-react';
const reviews = [{
  avatar: 'https://cdn.magicpatterns.com/uploads/bRDorQNi966SU2uTALtBSs/Disen-o-sin-ti-tulo-(41).png',
  name: 'Carlos M.',
  stars: 5,
  title: '¡Increíble material, todo muy claro!',
  date: 'Calificado en México el 15 de abril de 2026',
  format: 'PDF Digital',
  verified: true,
  text: 'Todo está explicado paso a paso. No tenía experiencia y ya estoy haciendo mis primeras instalaciones. Los diagramas son muy claros y fáciles de seguir. Vale totalmente la pena, lo recomiendo a cualquier persona que quiera aprender comandos eléctricos desde cero.',
  helpful: 24,
  translated: true
}, {
  avatar: 'https://cdn.magicpatterns.com/uploads/pK6zp7AMwMqLxumx5zQYM1/fee6b92aff3d1bb23295eb0cc23a173c-(1).jpg',
  name: 'Luis R.',
  stars: 5,
  title: 'De principiante a conseguir trabajos reales',
  date: 'Calificado en Colombia el 8 de marzo de 2026',
  format: 'PDF Digital',
  verified: true,
  text: 'No sabía nada de electricidad… ahora incluso estoy consiguiendo trabajos. Muy fácil de entender y aplicar. El simulador que viene como bono es excelente para practicar antes de ir a un trabajo real. Sin duda la mejor inversión que he hecho este año.',
  helpful: 11,
  translated: false
}];
function AmazonStars({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-[0.5px]" data-id="element-13">
      {Array.from({
      length: 5
    }).map((_, i) => <svg key={i} viewBox="0 0 24 24" className="w-[16px] h-[16px]" fill={i < count ? '#FFA41C' : '#E0E0E0'} data-id="element-14">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-15" />
        </svg>)}
    </div>;
}
export function AmazonReviewsSection() {
  const [expandedReviews, setExpandedReviews] = useState<Set<number>>(new Set());
  const toggleExpand = (index: number) => {
    setExpandedReviews(prev => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);else next.add(index);
      return next;
    });
  };
  return <div className="mt-8 max-w-3xl mx-auto bg-white rounded-2xl border border-gray-200 p-5 md:p-7 shadow-[0_2px_12px_rgba(0,0,0,0.04)]" data-id="element-16">
      <div className="flex items-center justify-between mb-5 pb-4 border-b border-gray-100" data-id="element-17">
        <h3 className="text-gray-900 font-bold text-[16px] md:text-[18px]" data-id="element-18">
          Opiniones de clientes
        </h3>
        <div className="flex items-center gap-2" data-id="element-19">
          <AmazonStars count={5} data-id="element-20" />
          <span className="text-[13px] text-gray-600 font-medium" data-id="element-21">
            4.9 de 5
          </span>
        </div>
      </div>

      <div className="space-y-6" data-id="element-22">
        {reviews.map((review, index) => {
        const isExpanded = expandedReviews.has(index);
        const shouldTruncate = review.text.length > 180;
        const displayText = !isExpanded && shouldTruncate ? review.text.slice(0, 180) + '…' : review.text;
        return <div key={index} className="pb-5 border-b border-gray-100 last:border-b-0 last:pb-0" data-id="element-23">
              <div className="flex items-center gap-2.5 mb-2" data-id="element-24">
                <img src={review.avatar} alt={review.name} className="w-9 h-9 rounded-full object-cover border border-gray-200" loading="lazy" data-id="element-25" />
                <span className="text-[13px] font-semibold text-gray-900" data-id="element-26">
                  {review.name}
                </span>
              </div>

              <div className="flex items-center gap-2 mb-1" data-id="element-27">
                <AmazonStars count={review.stars} data-id="element-28" />
                <span className="text-[13px] font-bold text-gray-900" data-id="element-29">
                  {review.title}
                </span>
              </div>

              <p className="text-[12px] text-gray-500 mb-1" data-id="element-30">{review.date}</p>

              {review.verified && <p className="flex items-center gap-1 text-[12px] text-[#067D62] font-bold mb-2" data-id="element-31">
                  <BadgeCheck className="w-3.5 h-3.5" data-id="element-32" />
                  Compra verificada
                  <span className="text-gray-400 font-normal ml-1" data-id="element-33">
                    · {review.format}
                  </span>
                </p>}

              <p className="text-[14px] text-gray-800 leading-relaxed mb-2" data-id="element-34">
                {displayText}
              </p>

              {shouldTruncate && <button onClick={() => toggleExpand(index)} className="text-[13px] text-[#007185] hover:text-[#C7511F] hover:underline font-medium mb-2" data-id="element-35">
                  {isExpanded ? 'Leer menos' : 'Leer más'}
                </button>}

              <div className="flex items-center gap-3 mt-2" data-id="element-36">
                <button className="flex items-center gap-1.5 text-[12px] text-gray-600 hover:text-gray-900 border border-gray-300 rounded-full px-3 py-1 hover:bg-gray-50 transition-colors" data-id="element-37">
                  <ThumbsUp className="w-3.5 h-3.5" data-id="element-38" />
                  Útil ({review.helpful})
                </button>
              </div>
            </div>;
      })}
      </div>
    </div>;
}